module.exports = __webpack_public_path__ + "img/location-category-store.e081316.webp";